export interface TableEntriesProps {
  value?: string;
  className?: string;
  children?: React.ReactNode;
}

export const TableCol = (props: TableEntriesProps) => {
  const { value, className } = props;
  return <th className={`py-2 px-4 border ${className}`}>{value}</th>;
};

export const TableRow = (props: TableEntriesProps) => {
  const { value, className, children = null } = props;
  return (
    <td className={`py-1 px-4 border ${className}`}>{children || value}</td>
  );
};
